import React, { useState } from "react";
import { Offcanvas } from "react-bootstrap";
import "./WithdrawalFilterOffcanvas.css";

function WithdrawalFilterOffcanvas({ options, show, handleClose, onApplyApp }) {
  const [selected, setSelected] = useState(options?.[0]); // default Completed

  const handleApply = () => {
    onApplyApp(selected);
    handleClose();
  };

  return (
    <section className="withdrawal_filter_parent">
      <Offcanvas
        show={show}
        onHide={handleClose}
        placement="bottom"
        className="filter_offcanvas common_offcanvas"
      >
        <Offcanvas.Body>
          <div className="filter_options_container">
            {options?.map((item, index) => (
              <div
                key={index}
                className={`filter_option ${
                  selected?.id === item.id ? "active" : ""
                }`}
                onClick={() => setSelected(item)}
              >
                {item.label}
              </div>
            ))}

            <div className="filter_buttons">
              <button className="btn-register" onClick={handleClose}>
                Cancel
              </button>

              <button className="btn_register_bg" onClick={handleApply}>
                Apply
              </button>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </section>
  );
}

export default WithdrawalFilterOffcanvas;
